import React, { Component } from "react";
import "w3-css/3/w3.css";

class FromCentimeterButton extends Component {
  handleClickButon = buttonId => {
    this.props.cmUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Centimeter to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <FeetButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <InchesButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <KilometersButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <MetersButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <MilesButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <YardsButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromFeetButton extends Component {
  handleClickButon = buttonId => {
    this.props.ftUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Feet to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <CentimetersButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <InchesButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <KilometersButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <MetersButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <MilesButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <YardsButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromInchesButton extends Component {
  handleClickButon = buttonId => {
    this.props.inUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Inches to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <CentimetersButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <FeetButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <KilometersButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <MetersButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <MilesButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <YardsButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromKilometersButton extends Component {
  handleClickButon = buttonId => {
    this.props.klUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Kilometers to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <CentimetersButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <FeetButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <InchesButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <MetersButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <MilesButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <YardsButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromMetersButton extends Component {
  handleClickButon = buttonId => {
    this.props.mUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Meters to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <CentimetersButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <FeetButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <InchesButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <KilometersButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <MilesButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <YardsButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromMilesButton extends Component {
  handleClickButon = buttonId => {
    this.props.miUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Miles to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <CentimetersButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <FeetButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <InchesButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <KilometersButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <MetersButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <YardsButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromYardsButton extends Component {
  handleClickButon = buttonId => {
    this.props.ydUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Yards to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <CentimetersButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <FeetButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <InchesButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <KilometersButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <MetersButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <MilesButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class CentimetersButton extends Component {
  handleUpButton = () => {
    let name = "cm";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="centimeter"
        >
          Centimeters
        </button>
      </span>
    );
  }
}

class FeetButton extends Component {
  handleUpButton = () => {
    let name = "ft";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="feet"
        >
          Feet
        </button>
      </span>
    );
  }
}

class InchesButton extends Component {
  handleUpButton = () => {
    let name = "in";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="inch"
        >
          Inches
        </button>
      </span>
    );
  }
}

class YardsButton extends Component {
  handleUpButton = () => {
    let name = "yd";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="yards"
        >
          Yards
        </button>
      </span>
    );
  }
}

class MilesButton extends Component {
  handleUpButton = () => {
    let name = "mi";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="mile"
        >
          Miles
        </button>
      </span>
    );
  }
}

class MetersButton extends Component {
  handleUpButton = () => {
    let name = "m";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="meter"
        >
          Meters
        </button>
      </span>
    );
  }
}

class KilometersButton extends Component {
  handleUpButton = () => {
    let name = "kl";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="kilometer"
        >
          Kilometers
        </button>
      </span>
    );
  }
}

export {
  FromCentimeterButton,
  FromFeetButton,
  FromInchesButton,
  FromKilometersButton,
  FromMetersButton,
  FromMilesButton,
  FromYardsButton
};
